export const phrases = {
  heading_settings_sort: "Sortarea listei de personal",
  body_settings_sort: "Sortați lista de personal după nume sau prenume.",
  since_o_clock: "De la {time} ceas",
  old_data_warning_my_area: "Nu am putut încărca nicio informație nouă. Asigurați-vă că sunteți conectat la internet.",
  no_data_warning_my_area: "Asigurați-vă că sunteți conectat la internet și încercați din nou.",
  no_data_available_my_area: "Nu pot fi încărcate date",
  last_update_data: "Ultima actualizare",
  something_went_wrong_absences: "Ceva a mers prost. Vă rugăm să încercați din nou la o dată ulterioară.",
  something_went_wrong_with_the_pin_entry: "Ceva nu a mers bine cu introducerea PIN-ului...",
  pin_must_be_four_digits: "PIN-ul trebuie să fie format din exact patru cifre.",
  pins_do_not_match: "PIN-urile introduse nu se potrivesc.",
  pin_is_not_numerical: "PIN-ul poate fi format numai din numere.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Ștampilați",
  finish_break: "Sfârșitul pauzei",
  finish_loading_time: "Timp de încărcare finală",
  finish_driving_time: "Sfârșitul timpului de conducere",
  finish_business_trip: "Sfârșitul perioadei de serviciu",
  finish_project_as_task: "Finalizarea proiectului",
  finish_special_one: "Sfârșit Special1",
  finish_special_two: "Sfârșit Special2",
  you_clockout: "Tu te-ai ștampilat",
  sentence_work_time: "Sunteți la lucru. | Lucrezi chiar acum.",
  sentence_break: "Vă luați o pauză. | Ăsta e un moment de pauză.",
  sentence_loading_time: "În prezent înregistrați timpul de încărcare. Hauruck! | Înregistrați în prezent timpul de încărcare. Jerk!",
  sentence_business_trip: "Serviciu autentificat. Distracție plăcută!",
  sentence_driving_time: "Rezervați timp de condus. Puneți-vă centura și plecați! | Rezervați timpul de călătorie. Puneți-vă centura și plecați!",
  sentence_special_one: "Faceți o rezervare pentru Special 1. | Rezervați Special 1.",
  sentence_special_two: "Rezervați Special 2. | Rezervați Special 2.",
  sentence_custom_time: "Faceți rezervarea | Faceți rezervarea",
  you_are_booked_in_activity: "Ștampilați {activity}! | Ștampilați {activity}!",
  substitute_warning: "{ days } În cazul absențelor de câteva zile sau mai mult, trebuie să se numească un adjunct.",
  substituted_by: "Reprezentată de",
  name_clocked_in: "{name} ștampilată",
  /************************************/
  //Signature stuff:

  signature: "Semnătură",
  please_sign: "Vă rugăm să semnați",
  signature_with_date: "Semnătură de la {date}",
  signature_with_date_with_name: "Semnătura {date} de la {name}",
  signature_with_date_with_location: "Semnătura {date} în {location}",
  signature_with_date_with_name_with_location: "Semnătura lui {date} din {name} în {location}",
  signature_with_name: "Semnătura {name}",
  signature_with_name_with_location: "Semnătura {name} în {location}",
  signature_with_location: "Semnătura în {location}",
  /*************************************/

  accept_terms_and_conditions: "Prin trimiterea formularului, acceptați {agb} și {datenschutzerklaerung}.",
  what_is_your_name: "Cum te cheamă?",
  your_email: "Adresa dvs. de e-mail",
  what_is_your_company_name: "Care este numele companiei dumneavoastră?",
  what_do_you_want_to_do_with_clockin: "Ce vrei să faci cu clockin?",
  almost_finished: "Aproape am ajuns",
  test_clockin_for_amount_period: "Testați gratuit, timp de câteva zile, clockin {amountOfDaysTestPeriod} !",
  code_needed_to_connect: "Utilizați codul dvs.",
  you_have_no_company_code: "Nu aveți un cod? Contactați persoana din cadrul companiei dumneavoastră.",
  connect_your_device: "Conectați-vă dispozitivul!",
  please_type_in_device_id: "Vă rugăm să introduceți ID-ul dispozitivului, pe care îl găsiți pe site-ul nostru web, la secțiunea Dispozitive mobile.",
  new_at_clockin: "Ești nou la clockin?",
  pin_repeat: "Repetați PIN-ul",
  configure_your_pin: "Setați PIN-ul din 4 cifre",
  configure_your_pin_text: "Aveți nevoie de PIN pentru a accesa zona personală de pe terminalul tabletă.",
  congratulations: "Felicitări!",
  start_now: "Începeți acum",
  device_name_info: "Puteți schimba numele dispozitivului mobil, astfel încât să puteți ține evidența mai multor dispozitive. Exemplu: \"Smartphone MaxMustermann\". De asemenea, numele poate fi modificat ulterior.",
  select_project: "Selectați proiectul",
  select_time: "Timp selectat",
  create_new_account: "Creați un cont nou",
  join_my_company: "Alătură-te companiei mele",
  join_clockin_with_qr: "Înscrieți-vă cu codul QR",
  change_project: "Proiect de schimbare",
  my_messages: "Știrile mele",
  my_documents: "Documentele mele",
  my_data_and_passwords: "Datele și parolele mele",
  my_account_data: "Datele mele",
  change_my_password: "Modificați parola",
  forgot_password: "Nu-mi știu parola.",
  open_camera: "Deschideți camera",
  scan_now: "Scanați acum",
  sync_now: "Sincronizați acum",
  clear_logs: "Jurnalele goale",
  saveAndGoBack: "Salvare și returnare",
  full_day: "Zi întreagă",
  activate_scanner: "Scanerul este activat",
  scanner_is_inactive: "Scanner inactiv",
  change_project_by_scan_qr: "Scanați codul QR al proiectului la care doriți să treceți.",
  scan_device_by_qr: "Scanați codul QR de pe dispozitivul pe care doriți să îl utilizați.",
  no_access_to_camera_please_connect_device_manually: "Din păcate, camera nu a putut fi accesată, vă rugăm să introduceți manual codul dispozitivului.",
  no_access_to_camera_please_clockin_manually: "Din păcate, nu a fost posibil accesul la cameră, vă rugăm să aplicați ștampila manual.",
  qr_code_login: "Înregistrarea codului QR",
  scan_to_login: "Scanați codul QR pentru a vă autentifica.",
  checklist_was_saved: "Lista de verificare a fost salvată",
  question_save_changes_short: "Salvați modificările?",
  question_save_changes: "Doriți să salvați modificările?",
  question_delete_checklist_short: "Ștergeți lista de verificare?",
  question_delete_checklist: "Sunteți sigur că doriți să ștergeți lista de verificare?",
  checklist_is_sending: "Lista de verificare va fi trimisă",
  checklist_sent_successfully: "Lista de verificare trimisă cu succes 🎉",
  checklist_could_not_be_sent: "Lista de verificare nu a putut fi trimisă, vă rugăm să încercați din nou mai târziu.",
  checklist_transmission_problems_in_the_past: "În trecut, au existat probleme de transfer cu unele fișiere.",
  checklist_send_with_potential_data_loss: "Doriți să încercați să trimiteți lista de verificare fără aceste fișiere?",
  documentation_is_sending: "Se trimite documentația proiectului",
  documentation_sent_successfully: "Documentația proiectului a fost trimisă cu succes 🎉",
  confirm_documentation_dismissal: "Chiar vreți să aruncați documentația?",
  discard_unsaved_changes: "Vrei să renunți la schimbările tale?",
  documentation_will_be_sent_when_online: "Documentația va fi trimisă imediat ce veți fi din nou online.",
  confirmation_is_sending: "Se trimite confirmarea proiectului",
  ask_for_geo_permission: "Această aplicație are nevoie de locația ta, " + "dar nu are permisiunea de a face acest lucru.\n\n" + "Doriți să deschideți setările?",
  all_projects: "Toate proiectele",
  half_day: "Jumătate de zi",
  start_end: "În funcție de timp",
  my_area: "Zona mea",
  my_area_video_teaser_clockin_explained_by_frederik: "clockin explicat de Freddi",
  add_time: "Creați timp",
  show_times_in_confirmation: "Orele de spectacol în confirmare",
  change_time: "Timp de schimbare",
  finish_project: "Proiect complet",
  finish_project_date: "Finalizarea numirii",
  unfinish_project: "Redeschideți proiectul",
  unfinish_project_date: "Redeschideți numirea",
  absence_overview: "Gestionați absențele",
  edit_absence: "Editați absența",
  edited_absence: "Absență editată",
  created_absence: "Cerere de concediu creată cu succes",
  creating_absence: "Cererea dumneavoastră de concediu este acum creată",
  error_creating_absence: "Eroare la crearea cererii de absență",
  create_absence: "Creați absența",
  deleted_absence: "Cerere de absență retrasă",
  new_request: "Aplicație nouă",
  your_requests: "Aplicațiile dumneavoastră",
  planned_days: "Zile programate",
  planned_hours: "Program programat",
  used_days: "Zile utilizate",
  used_hours: "Ore petrecute",
  free_days: "Zile libere",
  free_hours: "Program de vacanță",
  open_days: "Zile deschise",
  open_hours: "Program de lucru",
  withdraw_request: "Retragerea cererii",
  change_request: "Cerere de modificare",
  request_was_approved: "Cererea dumneavoastră a fost aprobată",
  request_is_pending: "Cererea dumneavoastră nu a fost încă aprobată",
  request_was_rejected: "Cererea dumneavoastră a fost respinsă",
  add_attachment: "Adăugați atașament",
  message_optional: "Mesaj (opțional)",
  filed_on: "Prezentat pe",
  this_year: "În acest an",
  search_sub_projects: "La ce subproiect ați dori să lucrați?",
  error_occurred: "A apărut o eroare, încercați din nou mai târziu.",
  re_record: "Să șterg și să re-înregistrezi acest videoclip?",
  delete_video: "Șterge înregistrarea?",
  no_results_found: "Nu s-au găsit rezultate",
  record_again: "Reîncercare",
  request_valid_email: "Vă rugăm să introduceți o adresă de e-mail validă.",
  request_valid_company_name: "Vă rugăm să introduceți un nume de companie valid.",
  request_valid_first_name: "Vă rugăm să introduceți un prenume valid.",
  request_valid_last_name: "Vă rugăm să introduceți un nume de familie valid.",
  total_duration_today: "Timp total astăzi",
  show_daily_protocol: "Afișați jurnalul zilnic",
  change_profile_pic: "Schimbarea imaginii de profil",
  logout_account: "Deconectați contul",
  you_are_working: "Tu lucrezi chiar acum!",
  you_are_taking_a_break: "Ești în pauză!",
  activity_edited: "Activitate editată",
  activity_edited_undo: "Prelucrare anulată cu succes",
  activity_edited_missing_project: "Oh, proiectul încă lipsește!",
  activity_deleted: "Activitate ștearsă",
  activity_deleted_undo: "Activitate ștearsă restaurată",
  activity_created: "Activitate nouă creată",
  activity_created_undo: "Activitate nou creată retrasă",
  correct_working_hours: "Timpii de lucru corecți",
  your_changes_are_being_saved: "Modificările dvs. sunt acum salvate.",
  manage_working_hours: "Gestionați orele de lucru",
  delete_activity: "Ștergeți activitatea",
  start_navigation: "Începeți navigarea",
  no_valid_email: "Adresa de e-mail introdusă nu este validă.",
  delete_checklist: "Ștergeți lista de verificare",
  active_checklists: "Liste de verificare active",
  scan_qr_code: "Scanați codul QR",
  switch_to_office_center: "Treceți la centrul de birouri",
  confirm_project_completion_short: "Proiect complet",
  confirm_project_date_completion_short: "Finalizarea numirii",
  project_completed: "Proiect finalizat!",
  project_date_completed: "Numire finalizată!",
  confirm_project_uncompletion_short: "Redeschideți proiectul",
  confirm_project_date_uncompletion_short: "Redeschideți numirea",
  project_uncompleted: "Proiect activat",
  project_date_uncompleted: "Data activării",
  choose_project: "Selectați proiectul",
  choose_sub_project: "Selectați subproiectul",
  choose_site: "Selectați locația",
  active_projects: "Proiecte active",
  completed_term: "completat",
  completed_projects: "Proiecte finalizate",
  end_of_work: "Vă doresc o seară plăcută",
  correct_time: "Ora corectă",
  you_stamp_x: "Ștampilați",
  enter_pin: "Vă rugăm să introduceți PIN-ul",
  wrong_pin: "Introducerea incorectă a PIN-ului",
  pin_change_required: "Vi s-a cerut să vă schimbați PIN-ul",
  enter_new_pin: "Introduceți noul PIN",
  approve_pin: "Confirmați PIN-ul",
  no_projects_scheduled: "Pentru {day} Nu sunt stocate proiecte.",
  you_clock_in_project: "De acum înainte, înregistrați timpul de lucru al proiectului.",
  project_scan_error: "Acest cod nu este valabil pentru niciun proiect.",
  show_more_days: "arată mai multe zile",
  show_more_times: "Afișați mai multe ori",
  only_show_today: "Arată doar astăzi",
  todays_total_time: "Timp total astăzi",
  everything_synced: "Datele dumneavoastră sunt actualizate!",
  upload_in_progress: "Datele sunt încărcate...",
  who_are_you: "Cine eşti?",
  is_uploading_to_server: "Modificările dvs. sunt transferate la centrul de birouri.",
  offline_and_data_is_stored_locally: "Modificările dvs. vor fi transferate în curând la centrul de birouri. ",
  show_more: "arată mai mult",
  activity_edited_wrong_date: "Ați introdus o dată greșită.",
  confirm_logout: "Chiar doriți să vă dezabonați?",
  confirm_clockout: "Ești sigur că vrei să te retragi astăzi?",
  gps_is_active: "Datele GPS sunt transmise",
  location_tracking_is_active: "Pentru a activa urmărirea prin GPS.",
  app_settings: "Setările aplicației",
  clock_reminder: "Ștampilă - Reamintire",
  mon_to_fri: "Standard: de luni până vineri",
  logout: "Deconectați contul",
  refresh: "Actualizare",
  prompt_language_settings: "Setați aici limba aplicației.",
  prompt_clock_reminder: "Reamintire prin notificare push pentru a se potrivi cu munca ta zilnică.",
  register_company: "Înregistrarea companiei",
  use_code: "Utilizați codul",
  our_customers: "Clienții noștri",
  free_test_now: "Testați acum gratuit",
  tier_attendance: "Eu înregistrez doar orele de lucru și pauzele.",
  tier_documentation: "De asemenea, vreau să înregistrez orele de lucru pentru proiectele pe care le gestionez în ceas.",
  your_tier: "Pachetul dumneavoastră",
  all_clockin_functions: "Toate funcțiile clockin",
  checklists_formulars: "Liste de verificare și funcții",
  projectfile_incl_chat: "Fișiere digitale ale proiectului (inclusiv chat)",
  photo_sketch_note: "Funcția de fotografie, schiță și notițe",
  digital_signature: "Semnături digitale",
  datev_connection: "Conexiune DATEV",
  calendar_absences: "Gestionați calendarul și absențele",
  individual_design: "Privire individuală",
  attendance_time_tracking: "Înregistrarea timpului de staționare prin intermediul terminalului de tabletă",
  mobile_time_tracking: "Înregistrarea mobilă a timpului prin intermediul aplicației pentru smartphone",
  browser_time_tracking: "Înregistrarea timpului de navigare pe PC pentru biroul de acasă",
  help_use_code: "Vă rugăm să introduceți codul pe care îl găsiți în office center la rubrica dispozitive mobile/angajați.",
  wrong_code: "Cod greșit",
  wrong_code_text: "Codul nu este valabil. Vă rugăm să încercați din nou cu un cod valid",
  wrong_code_text_short: "Codul este invalid",
  clockin_logo: "Logo-ul Clockin",
  invalid_qr_code: "Cod QR nevalid",
  invalid_qr_code_text: "Codul QR scanat nu este valid. Vă rugăm să scanați un cod de ceas valid.",
  code_already_connected: "Cu acest cod vă puteți conecta dispozitivul. Dar sunteți deja conectat.",
  wrong_credentials: "Date de acces incorecte",
  wrong_credentials_text: "Combinația de e-mail și parolă pe care ați introdus-o nu a putut fi găsită. Vă rugăm să verificați datele introduse și să încercați din nou.",
  new_pin: "Introduceți noul PIN",
  choose_next_action: "Alegeți următoarea acțiune",
  name_of_software_package: "Denumirea pachetului de software",
  select_teamleader: "Cine ștampilează pentru echipă?",
  select_teamleader_description: "Pentru a continua activitățile de ștampilare, vă rugăm să selectați o persoană care va prelua acum mașina.",
  clocked_in_on_this_device: "Ștampilat pe această unitate",
  not_clocked_in_on_this_device: "Nu este ștampilat pe această unitate",
  select_new_teamleader: "Cine ar trebui să ștampileze pentru echipă acum?",
  switch_teamleader: "Predați unitatea",
  just_me: "Tocmai am ieșit.",
  select_the_new_teamleader: "Determinați noul lider de echipă",
  back_to_selection: "înapoi la selecție",
  manage_team: "Gestionați echipa",
  total_time_team: "Timpul total al echipei",
  count_members_clocked_in: "{clockedin}/{members} Membrii echipei ștampilate în",
  whole_team: "Întreaga echipă",
  teammembers_still_clockedin: "Alegeți dacă doriți să vă cronometrați doar pe dvs. sau pe toți cei din echipă?",
  clockout_all: "Elimină toate",
  select_employee: "Mai întâi selectați un utilizator",
  something_went_wrong: "Ceva nu a mers bine, vă rugăm să încercați din nou mai târziu.",
  new_pin_successfully_changed: "PIN schimbat cu succes",
  enter_pin_before_clockin_prompt: "În primul rând, introduceți PIN-ul pe rând pentru a vă ponta.",
  enter_pin_before_clockout_prompt: "Introduceți mai întâi PIN-ul, pe rând, pentru a vă deconecta.",
  delete_activity_alert_title: "Ștergeți activitatea",
  delete_activity_alert_msg: "Sunteți sigur că doriți să ștergeți activitatea?",
  delete_absence_message: "Sunteți sigur că doriți să retrageți cererea?",
  delete_absence_title: "Retragerea cererii",
  are_you_sure: "Ești sigur?",
  request_password: "Solicitați o nouă parolă",
  password_requested: "Un link pentru o nouă parolă a fost trimis la adresa dvs. de e-mail.",
  no_email_retrieved: "Nu ați primit un e-mail? Vă rugăm să verificați dosarul de spam sau să încercați din nou.",
  name_of_customer: "Numele clientului",
  missing_permissions_homepage_text: "Nu aveți permisiunea de a vă modifica activitatea pe acest computer. Vă rugăm să contactați administratorul dvs. pentru a obține acces.",
  no_permission_warning_my_area: "Nu aveți permisiunea de a accesa această zonă. Vă rugăm să contactați administratorul dvs. pentru a obține acces.",
  employee_clocked_in: "{name} înregistrat!",
  employee_clocked_out: "{name} deconectat!",
  no_employee_to_qr_code_warning: "Nu a putut fi găsit niciun angajat pentru acest cod QR.",
  no_employees_registered_heading: "Încă nu a fost alocat personal pentru această unitate.",
  no_employees_registered_body: "În centrul de birou, în setările dispozitivului mobil, puteți atribui angajaților care pot înregistra orele de lucru pe acest dispozitiv.",
  no_employee_found: "Din nefericire, nu a putut fi găsit nimeni cu acest nume.",
  no_employee_assigned: "Niciun angajat desemnat",
  you_need_help: "Aveți nevoie de ajutor?",
  here_you_can_get_help_to_register_employees_for_device: "Aici veți găsi toate informațiile despre cum să repartizați personalul unei unități.",
  show_time: "Creați timp",
  export_timesheet: "Exportați foaia de pontaj",
  select_month: "Selectați luna",
  internet_connection_required: "Pentru aceasta este necesară o conexiune la internet.",
  select_an_activity_to_clockin_your_team: "Selectați o activitate de ștampilat în echipa dumneavoastră.",
  confirm_uploading_sqlite_for_debugging: "Sunteți sigur că doriți să încărcați datele în aplicație pentru suportul Clockin?",
  no_tasks_available: "Nicio activitate disponibilă",
  click_to_add_tasks: "Click pentru a adăuga sarcini",
  scan_nfc_tag: "Vă rugăm să țineți cardul la cititor.",
  link_nfc_tag: "Legați eticheta NFC",
  select_employee_for_nfc_tag: "Vă rugăm să selectați un angajat pentru a lega această etichetă NFC:",
  nfc_tag_linked_successfully: "NFC cu succes cu {name} Legate.",
  nfc_linking_failed: "Eticheta NFC nu a putut fi legată. Vă rugăm să încercați din nou.",
  nfc_not_enabled: "NFC nu este acceptat de acest dispozitiv sau este dezactivat.",
  nfc_initialization_failed: "Din păcate, ceva nu a mers bine. Vă rugăm să încercați din nou.",
  nfc_scan_failed: "Din păcate, ceva nu a mers bine. Vă rugăm să încercați din nou.",
  nfc_no_tag_found: "Nu a fost găsită nicio etichetă NFC.",
  nfc_tag_already_linked_to: "Această etichetă NFC este deja disponibilă cu {name} Legate.",
  nfc_scan_active: "Scanare NFC activă",
  nfc_linking_enabled: "Etichetele NFC pot fi acum conectate. Vă rugăm să țineți eticheta NFC pentru a fi legată de cititorul NFC acum.",
  nfc_all_employees_linked: "Toți angajații alocați acestui dispozitiv au fost deja conectați.",
  no_employee_to_nfc_warning: "Nu a putut fi găsit niciun angajat pentru această etichetă NFC.",
  select_employee_to_link_nfc: "Cui ar trebui să fie legată eticheta NFC?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Bine ai venit la Clockin",
        clocking_time: "Timpi pe circuit",
        push_notifications: "Nu uita nimic"
      },
      text: {
        clocking_time: "Cronometrul este punctul tău de plecare pentru fiecare activitate. Tu te ocupi de munca ta, aplicația se ocupă de documentație.",
        push_notifications: "Acum activează notificările. Clockin îți amintește dacă uiți o ștampilă și se asigură că primești tot ce este important imediat."
      },
      button: {
        lets_go: "Începeți acum"
      }
    },
    my_area: {
      heading: {
        my_area: "Zona mea",
        absences: "Absențe și cereri",
        settings: "Setări personale"
      },
      text: {
        my_area: "Locul central în care aveți o imagine de ansamblu instantanee a orelor de lucru și a orelor suplimentare. De aici puteți să vă gestionați orele de lucru, să accesați jurnalul zilnic, să trimiteți cereri și să vă vizualizați orele.",
        absences: "Gestionați cererile de concediu, zilele de concediu medical și alte absențe. Urmăriți în permanență starea cererilor dvs. și trimiteți cereri noi rapid și ușor, cu doar câteva clicuri.",
        settings: "Trimiteți mesaje către companie sau modificați-vă setările personale, iar dacă doriți să vă schimbați parola, o puteți face și aici!"
      },
      button: {
        lets_go: "Începe"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Pentru că timpul tău contează",
        clock_in: "Ștampila în",
        switch_task: "Schimbarea ștampilei",
        clock_out: "Ștampilați",
        thats_it: "Asta e!"
      },
      text: {
        your_time_matters: "Cu clockin vă ajutăm să vă concentrați asupra lucrurilor esențiale. Înregistrați-vă timpul de lucru cu un singur clic.",
        clock_in: "Cu un singur clic sunteți înregistrat direct. Clockin vă salvează automat datele și aveți totul la vedere în orice moment.",
        switch_task: "Aveți un alt proiect, luați o pauză sau vă îndreptați spre următoarea întâlnire? Nu trebuie decât să vă reștampilați pentru noua dvs. activitate. Restul este înregistrat automat.",
        clock_out: "Și cu un singur clic sunteți ștampilat.",
        thats_it: "Ați făcut-o și sunteți gata să vă înregistrați timpul de lucru. Dacă aveți nevoie de ajutor, contactați-ne. Totul este ușor cu clockin - inclusiv comunicarea cu noi."
      },
      button: {
        your_time_matters: "Arată-mi cum se face",
        thats_it: "Începeți acum"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Pentru că timpul tău contează",
        clock_in: "Ștampila în",
        clock_in_team: "Echipa de check-in",
        switch_task: "Schimbarea ștampilei",
        change_teamleader: "Predați unitatea",
        clock_out: "Ștampilați",
        thats_it: "Asta e!"
      },
      text: {
        your_time_matters: "Cu clockin vă ajutăm să vă concentrați asupra lucrurilor esențiale. Înregistrați orele de lucru ale echipei dvs. cu un singur clic.",
        clock_in: "Selectați o persoană care face pontajul pentru echipă și, cu un singur clic, sunteți înregistrat direct. clockin salvează datele în mod automat și puteți supraveghea totul în orice moment.",
        clock_in_team: "Pur și simplu, ștampilați direct echipa dumneavoastră. Fie că toți în același timp, fie că este vorba de membri individuali.",
        switch_task: "Aveți un alt proiect, luați o pauză sau vă deplasați la următoarea întâlnire? Nu trebuie decât să ștampilați noua dvs. activitate. Restul va fi înregistrat automat.",
        change_teamleader: "Ați terminat lucrul, trebuie să plecați sau nu mai pontați pentru echipă? Pur și simplu predați dispozitivul în aplicație și totul revine la normal.",
        clock_out: "Și cu un singur clic, dvs. și echipa dvs. sunteți gata de plecare. Bineînțeles, puteți, de asemenea, să cronometrați membrii individuali în orice moment.",
        thats_it: "Ați făcut-o și sunteți gata să înregistrați timpul de lucru pentru echipa dumneavoastră. Dacă aveți nevoie de ajutor, nu trebuie decât să ne contactați. Totul este ușor cu clockin - inclusiv comunicarea cu noi."
      },
      button: {
        your_time_matters: "Arată-mi cum se face",
        thats_it: "Începeți acum"
      }
    },
    my_area: {
      heading: {
        welcome: "Bine ați venit în zona dumneavoastră",
        my_area: "Zona mea",
        create_time: "Creați timp",
        change_time: "Ora corectă",
        absences: "Absențe și cereri",
        settings: "Setări personale",
        thats_it: "Asta e!"
      },
      text: {
        welcome: "Descoperiți și mai multe modalități de a vă gestiona eficient și ușor timpul de lucru. Să aruncăm o privire la zona dvs.",
        my_area: "Locul central în care aveți o imagine de ansamblu instantanee a orelor de lucru și a orelor suplimentare. De aici puteți să vă gestionați orele de lucru, să accesați jurnalul zilnic, să trimiteți cereri și să vă vizualizați orele.",
        create_time: "Ați uitat să introduceți o oră sau doriți să adăugați ore mai târziu? Nicio problemă! Adăugați orele lipsă, înregistrați pauzele și țineți la zi contul dvs. de timp de lucru.",
        change_time: "Doriți să vă corectați timpii? Nici o problemă! Cu clockin puteți corecta și ajusta cu ușurință orele incorecte.",
        absences: "Gestionați cererile de concediu, zilele de concediu medical și alte absențe. Urmăriți în permanență starea cererilor dvs. și trimiteți cereri noi rapid și ușor, cu doar câteva clicuri.",
        settings: "Trimiteți mesaje către companie sau modificați-vă setările personale, iar dacă doriți să vă schimbați parola, o puteți face și aici!",
        thats_it: "Ați reușit! Acum puteți să vă gestionați fără efort timpul, să vă organizați absențele și să vă concentrați asupra a ceea ce este important: munca dumneavoastră. Mult succes în timpul productiv!"
      },
      button: {
        welcome: "Arată-mi cum se face",
        thats_it: "Începeți acum"
      }
    },
    clock: {
      clockin_now: "Blocați acum",
      clock_your_first_time_now: "& înregistrați prima dată"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Vă mulțumim pentru utilizarea clockin!",
      question: "Cât de probabil este că veți recomanda clockin prietenilor sau colegilor?",
      very_likely: "Foarte probabil",
      very_unlikely: "Foarte puțin probabil",
      help_us_improve: "Cum putem îmbunătăți ceasul pentru dvs.?",
      what_do_you_agree_with: "Cu ce afirmații sunteți de acord?",
      choose_three_statements: "Alegeți până la trei afirmații.",
      hard_to_use: "Dificil de utilizat",
      lacking_features: "Prea puține funcții",
      does_not_help_me: "nu-mi ușurează ziua de lucru",
      confusing: "confuz",
      poorly_implemented: "Funcții slab implementate",
      too_buggy: "prea predispuse la erori",
      too_slow: "Timpi lungi de încărcare",
      what_else: "Doriți să ne mai spuneți ceva?",
      can_we_ask_you_a_few_questions: "Putem să vă mai punem câteva întrebări?",
      how_happy_are_you_with_the_introduction_of_clockin: "Cât de mulțumit sunteți de introducerea sistemului de pontaj în compania dumneavoastră?",
      how_much_do_you_enjoy_using_clockin: "Cum vă place să folosiți clockin?",
      how_much_easier_does_clockin_make_your_work: "Cât de mult vă ușurează munca de zi cu zi ceasul?",
      how_happy_are_you_with_the_following_aspects: "Cât de mulțumit sunteți de următoarele puncte?",
      clarity_of_the_app: "Claritatea aplicației",
      simplicity_of_use: "Simplitate de funcționare",
      app_features: "Funcții în aplicație",
      feedback_received: "Feedback-ul dvs. a fost primit. Vă mulțumim pentru timpul acordat.",
      thanks_for_taking_the_time: "Vă mulțumim pentru timpul acordat.",
      what_can_we_do_to_improve: "Puteți să ne spuneți mai multe despre experiența dvs., astfel încât să ne putem descurca și mai bine data viitoare?",
      what_can_we_do_to_get_it_right: "Puteți să ne spuneți mai multe despre experiența dvs. pentru ca data viitoare să o facem cum trebuie?",
      comment_placeholder: "Mesajul dvs."
    }
  },
  travel_logs: {
    add: "Adăugați detaliile călătoriei",
    edit: "Editați detaliile călătoriei",
    saving: "Detaliile călătoriei sunt salvate...",
    saved_successfully: "Detaliile călătoriei au fost salvate cu succes!",
    unable_to_save: "Din păcate, asta nu a mers 😢"
  },
  attach_file: "Atașați fișierul",
  image_to_text: {
    info: "Asigurați-vă că textul este clar recognoscibil și poate fi văzut în întregime pe imagine.",
    attach_image: "Atașați o imagine",
    processing: "Textul dvs. va fi citit în.",
    processing_failed: "Din păcate, importul nu a funcționat 😢",
    no_text_found: "Nu a putut fi recunoscut niciun text."
  },
  correction_enter_reason: "Vă rugăm să furnizați un motiv pentru corectare.",
  daily_notes: {
    add: "Scrieți o notă",
    edit: "Notă de editare",
    saving: "Nota este salvată...",
    saved_successfully: "Notă salvată cu succes!",
    unable_to_save: "Din păcate, asta nu a mers 😢",
    no_notes_yet: "Nu a fost creată nicio notă",
    create_note: "Creați"
  },
  calendar_sync: {
    title: "Sincronizare program",
    description: "Sincronizează-ți programul de lucru cu un calendar și supraveghează întâlnirile vechi și noi.",
    url: "Adresă în format iCal",
    url_description: "Puteți utiliza această adresă pentru a accesa acest calendar din alte aplicații.",
    note: "Notă",
    note_description: "Cu unele calendare, poate dura până la 24 de ore pentru ca noile programări să fie afișate acolo.",
    sync_now: "Sincronizarea calendarului",
    copied: "Calendar url copiat."
  },
  registration: {
    skip_all: "Sari peste toate",
    already_signed_up: "Am deja un cont",
    title_1: "Să începem! Ce ore doriți să înregistrați cu Clockin?",
    description_1: "Permiteți-ne să personalizăm ceasul pentru dvs.",
    option_1_a: "Timp de lucru general (intrare, ieșire și pauză)",
    option_1_b: "Programul de lucru al proiectului",
    title_2: "Doriți să vă documentați?",
    description_2: "Ce cerințe trebuie îndeplinite pentru aceasta?",
    option_2_a: "Fotografii",
    option_2_b: "Schițe",
    option_2_c: "Notă funcție",
    option_2_d: "Liste de verificare și formulare",
    option_2_e: "Fișiere digitale de proiect",
    title_3: "Ce ați mai dori să digitalizați?",
    description_3: "Există mult mai multe de descoperit la Clockin, poate că există ceva pentru tine.",
    option_3_a: "Vacanță",
    option_3_b: "Îmbolnăviri și absențe",
    option_3_c: "Dosar personal digital",
    option_3_d: "Analiza companiei",
    option_3_e: "Planificarea implementării",
    option_3_f: "Consultant fiscal pentru transferul de date (DATEV)",
    title_4: "În ce sector activează compania dumneavoastră?",
    description_4: "Dorim să vă cunoaștem mai bine pentru a vă putea adapta mai bine clockin-ul la nevoile dumneavoastră.",
    option_4_a: "servicii",
    option_4_b: "Artizanat",
    option_4_c: "Sănătate și wellness",
    option_4_d: "Achiziții, comenzi și comerț",
    option_4_e: "Hotel și catering",
    option_4_f: "Automobile, transport și mașini",
    option_4_g: "Alte industrii",
    title_5: "Câți angajați are compania dumneavoastră?",
    description_5: "În funcție de numărul de angajați, putem personaliza programul de pontaj în funcție de mărimea companiei dumneavoastră.",
    title_6: "Super! Cronometrarea dvs. este acum configurată",
    description_6: "Tot ce ne trebuie este numele tău.",
    input_6_a: "Compania",
    input_6_b: "Prenume",
    input_6_c: "Numele de familie",
    input_6_d: "Număr de telefon",
    title_7: "Sunteți gata de plecare! Încearcă clockin 14 zile gratuit!",
    input_7_a: "Adresa dvs. de e-mail",
    description_7: "La ce adresă de e-mail trebuie să trimitem parola dumneavoastră?",
    input_7_b: "Așa am devenit conștient",
    how_did_you_hear_about_clockin: "Cum ați auzit prima dată despre clockin?",
    recommendation_option_1: "Recomandare",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Căutare pe internet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Platformă de comparare",
    recommendation_option_7: "Reviste și articole online",
    known_from: "Cunoscut de la",
    agb_1: "Prin trimiterea formularului, acceptați ",
    agb_2: 'AGB',
    agb_3: " și ",
    agb_4: "Politica de confidențialitate",
    start: "Începeți testul",
    validation_failed: "Vă rugăm să completați corect toate câmpurile."
  },
  clocki: {
    listening_heading: "Te ascult",
    listening_subtext: "cum te pot ajuta?",
    hi_0: "Bună ziua, cu ce vă pot ajuta?",
    hi_1: "Hei, cu ce te pot ajuta?",
    hi_2: "Bună ziua, cu ce vă pot ajuta?",
    hi_3: "Moin moin, ce pot face pentru tine?",
    hi_4: "Bună ziua, ce pot face pentru dvs.?",
    hi_5: "Bună ziua, cu ce vă pot ajuta?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Din păcate, recunoașterea vocală nu pare să funcționeze pe dispozitivul dvs.",
    microphone_permission_denied: "Din păcate, nu am acces la microfonul dvs. Vă rugăm să verificați autorizațiile din setări, astfel încât să vă pot auzi.",
    please_speak: "Acum puteți vorbi cu Clocki",
    create_activity: "Creați o activitate",
    modify_activity: "Schimbați activitatea",
    delete_activity: "Ștergeți activitatea",
    create_daily_note: "Creați o notă zilnică",
    search_project: "Căutarea unui proiect",
    note_copied: "Notă copiată",
    create_absence_request: "Solicitați absența",
    delete_absence: "Ștergeți absența",
    confirm_deletion: "Ești sigur că {activity_label} Ștanțare de la {date} Ceasul ar trebui șters?",
    confirm_absence_deletion: "Sunteți sigur că solicitarea dvs. {category} din {startDate} până {endDate} Vrei să ștergi?",
    task_before_modification: "Înainte: {task}",
    starts_at_before_modification: "Ora de începere înainte: {startsAt}",
    ends_at_before_modification: "Ora de sfârșit înainte: {endsAt}",
    something_went_wrong: "Oh, ceva nu a mers bine, vă rugăm să încercați din nou mai târziu.",
    was_this_helpful: "Te-ar putea ajuta Clocki?",
    actions: {
      CREATE_ABSENCE: {
        title: "Confirmați absența"
      },
      CREATE_DAILY_NOTE: {
        title: "Creați o notă acum",
        daily_notes_disabled: "Din păcate, funcția de notă este dezactivată. Vă rugăm să solicitați administratorului dvs. să activeze funcția în centrul de birouri.",
        success: "Notă salvată cu succes în jurnalul zilnic 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Creați documentația acum",
        created_by_clocki: "Creat cu Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Deschideți \"Timpurile mele\" acum"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Deschideți \"Zona mea\" acum"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Deschideți \"Schimbare parolă\" acum"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Ștampila \"timp de lucru\" acum",
        PAUSE: "Ștampila \"Pauză\" acum",
        DRIVING_TIME: "Ștampila \"durata călătoriei\" acum",
        LOGOUT: "Deblocați acum"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Îți place să folosești Clockin?"
  },
  translation_failed: "Din păcate, traducerea nu a funcționat 😕",
  video_transcript_not_available: "Nu există transcript disponibil",
  video_upload_succeeded: "Încărcarea video finalizată.",
  video_upload_failed: "Încărcarea video a eșuat.",
  video_send_failed: "Videoclipul nu a putut fi difuzat în acest moment. Vom încerca din nou mai târziu.",
  uploading_video: "Încărcare video...",
  language_selection_header: "Limbă selectată",
  language_selection_message: "Alege-ți limba preferată",
  shifts: {
    my_shifts: "Turele mele",
    free_shifts: "Ture libere",
    next_shift: "Următoarea ta tură",
    shift_not_found: "Nu s-au găsit straturi",
    show_shift_plan: "Consultați acest program de schimburi",
    no_shift_place: "Nicio locație specificată",
    no_shifts_assigned: "În prezent nu ești repartizat la niciun schimb",
    free_shifts_unavailable: "În prezent, turele libere nu sunt disponibile",
    filter_shift_plans: "Programe de schimburi de filtru",
    no_shift_plans_available: "Nu există programe de schimb disponibile",
    filter_locations: "Locuri de filtrare",
    no_locations_available: "Nu sunt locuri disponibile",
    no_plan_selected: "Nu a fost selectat un program de schimb",
    no_shifts_for_plan: "Nu s-au găsit straturi pentru acest plan",
    no_shifts_for_location: "Nu s-au găsit schimbări pentru locația selectată",
    unknown_shift_plan: "Program de schimb necunoscut",
    unknown_location: "Locație necunoscută",
    loading_more_shifts: "Încarcă mai multe straturi..."
  },
  clockin_reminder_title: "Ești deja la serviciu? 🔔",
  clockin_reminder: "Amintește-ți să te programezi.",
  clockout_reminder_title: "Ești deja la finalul zilei? 🔔",
  clockout_reminder: "Nu uita să termini pontajul.",
  choose_clockin_reminder_time: "Ora de rememorare a pontajului",
  choose_clockout_reminder_time: "Ora de reamintire a programului de plecare",
  choose_break_reminder_time: "Durata pauzei",
  saved_successfully: "Salvat 👍 cu succes",
  clock_reminder_channel_name: "Amintiri pentru timbre",
  clock_reminder_channel_description: "Memento-uri pentru a ponta la intrare și ieșire",
  break_reminder_title: "Încă iei o pauză? ⏰",
  break_reminder: "Notă: Timpul tău de pauză încă curge.",
  // Video component translations
  video_not_supported: "Dispozitivul tău nu suportă videoclipul :/",
  video_loading_error: "Eroare la încărcarea videoclipului",
  video_retry: "Reîncărcare"
};